import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (ticketId, query = {}) =>
  f3tch(`/crm/tickets/${ticketId}/notes/`)
    .profile(profile())
    .query(query)
    .get();
